<template>
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
  >
    <path d="M0.246643 1.74805C0.246643 1.33383 0.582429 0.998047 0.996643 0.998047H17.5007C18.1188 0.998047 18.4716 1.70369 18.1007 2.19811L13.9364 7.74927L18.1007 13.3004C18.4716 13.7948 18.1188 14.5005 17.5007 14.5005L1.74664 14.5V19.2499C1.74664 19.6296 1.46449 19.9434 1.09841 19.993L0.996643 19.9999C0.616947 19.9999 0.303152 19.7177 0.25349 19.3517L0.246643 19.2499V1.74805ZM16.0005 2.49805H1.74664V13.0005H16.0005L12.3989 8.19933C12.1988 7.93264 12.1988 7.5659 12.3989 7.29921L16.0005 2.49805Z" />
  </svg>
</template>
